/** Query keys for the `ad-format` slice. */
export const AD_FORMAT_QUERY_KEYS = {
  all: ['ad-formats'] as const,
  formatSpecs: () => [...AD_FORMAT_QUERY_KEYS.all, 'format-specs'] as const,
};
